module.exports = __webpack_public_path__ + "img/msfGif1.036d8740.gif";